import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import { Reveal } from '@/components/ui/Reveal'

interface SectionHeaderProps {
  title: string
  /** Trailing part of the heading, shown in green */
  accent?: string
  description?: ReactNode
  align?: 'left' | 'center'
  className?: string
}

/** Eyebrow + heading + intro used to open every body section. */
export const SectionHeader = ({
  title,
  accent,
  description,
  align = 'left',
  className,
}: SectionHeaderProps) => (
  <Reveal className={cn('mb-10', align === 'center' && 'text-center', className)}>
    <h2 className="font-display text-3xl leading-tight tracking-tight text-base-900 sm:text-4xl lg:text-[2.8rem]">
      {title}
      {accent && (
        <>
          {' '}
          <span className="text-green-700">{accent}</span>
        </>
      )}
    </h2>
    {description && (
      <div
        className={cn(
          'mt-5 max-w-2xl text-base leading-7 text-base-600',
          align === 'center' && 'mx-auto',
        )}
      >
        {description}
      </div>
    )}
  </Reveal>
)
